
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  Line,
  LineChart,
  CartesianGrid,
  Tooltip,
} from "recharts";

interface OperatorAnalyticsProps {
  isPremium: boolean;
  isBasic?: boolean;
}

const OperatorAnalytics: React.FC<OperatorAnalyticsProps> = ({ isPremium, isBasic }) => {
  // Sample data for the charts
  const viewsData = [
    { date: "Jan 10", views: 23, clicks: 7 },
    { date: "Jan 15", views: 45, clicks: 15 },
    { date: "Jan 20", views: 37, clicks: 12 },
    { date: "Jan 25", views: 52, clicks: 20 },
    { date: "Jan 30", views: 48, clicks: 18 },
    { date: "Feb 5", views: 65, clicks: 25 },
    { date: "Feb 10", views: 70, clicks: 30 },
  ];

  return (
    <Card className="shadow-sm mb-6">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Analytics Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[200px]">
          {isPremium ? (
            <ChartContainer
              config={{
                views: { label: "Views", color: "#33C3F0" },
                clicks: { label: "Clicks", color: "#8B5CF6" }
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={viewsData}>
                  <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                  <XAxis 
                    dataKey="date" 
                    fontSize={12} 
                    tickMargin={10}
                    stroke="#888"
                  />
                  <YAxis 
                    fontSize={12}
                    tickMargin={10}
                    stroke="#888"
                  />
                  <Tooltip
                    content={({ active, payload }) => {
                      if (active && payload && payload.length) {
                        return (
                          <ChartTooltipContent 
                            className="border-gray-200 shadow-lg"
                            payload={payload} 
                          />
                        );
                      }
                      return null;
                    }}
                  />
                  <Line 
                    type="monotone" 
                    dataKey="views" 
                    stroke="var(--color-views)"
                    strokeWidth={2}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6, strokeWidth: 0 }}
                  />
                  <Line 
                    type="monotone" 
                    dataKey="clicks" 
                    stroke="var(--color-clicks)"
                    strokeWidth={2}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6, strokeWidth: 0 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </ChartContainer>
          ) : (
            <div className="h-full flex flex-col items-center justify-center bg-gray-50 rounded-md border border-dashed border-gray-300">
              <p className="text-gray-500 font-medium mb-2">Premium Feature</p>
              <p className="text-gray-400 text-sm text-center max-w-xs">
                Upgrade to Premium to see detailed analytics about your profile views and engagement.
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default OperatorAnalytics;
